/**
 * Inscription par numéro de téléphone (OTP SMS). Désactivée tant que les
 * fournisseurs SMS (Nimba SMS / Infobip) ne sont pas configurés : seule
 * l'inscription par email est proposée. La connexion par téléphone des
 * comptes existants n'est pas concernée.
 */
export const PHONE_SIGNUP_ENABLED = false
